import React, { Component } from "react";
import Select from "react-select";
import styled from "styled-components";
import SelectSegmentDropDown from "components/Common/SelectSegmentDropDown";
import AudienceBaseClause from "components/Common/Clauses/AudienceBase";

class SegmentClause extends Component {
  render() {
    const { clause, updateClause, segmentBlacklist } = this.props;

    const operatorOptions = [
      { value: false, label: "matches" },
      { value: true, label: "doesn't match" }
    ];

    return (
      <AudienceBaseClause {...this.props}>
        <div className="segment-targeting sub-clause">
          <div className="select-segment-container">
            <SelectSegmentDropDown
              value={clause.segment}
              blacklist={segmentBlacklist}
              onChange={value =>
                updateClause(clause.id, {
                  segment: value
                })
              }
            />
          </div>
          <Select
            className="select-negative"
            clearable={false}
            value={!!clause.negative}
            options={operatorOptions}
            autosize={false}
            onChange={opt => {
              updateClause(clause.id, { negative: opt.value });
            }}
          />
        </div>
      </AudienceBaseClause>
    );
  }
}

// language=SCSS prefix=dummy{ suffix=}
export default styled(SegmentClause)`
  .segment-targeting {
    .select-operator {
      max-width: 75px;
    }

    .select-segment-container {
      padding-right: 10px;
    }

    .select-segment {
      width: 100%;

      .segment-option {
        display: flex;
        align-items: center;
      }
    }
  }
`;
